<template>
  <div class="word">
    <div class="fixed" v-if="!isWx">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon
              name="arrow-left"
              class="mar_r"
              @click="goback"
              size="0.4rem"
            />
          </div>
          <div style="text-align: center; font-size: 0.35rem">购房承诺书</div>
          <div style="width: 0.3rem"></div>
        </div>
      </div>
    </div>
    <div class="fixed_pad" v-if="!isWx"></div>
    <div class="title">购房承诺书</div>
    <div class="title_one">
      承诺人：&nbsp;&nbsp;，性别&nbsp;&nbsp;&nbsp;，公民身份号码：
    </div>
    <div class="title_2">
      本人___拟申购_____项目房产，使用徐州市房地产信息网报名，我承诺:本人在报名过程所填写的信息及提交的材料均属实，如因不实信息导致无法报名，后果由我承担，若违反相关法律规定，愿意承担一切法律责任，并连带赔偿相关单位和个人的一切经济损失。为确保购房过程公开、透明，本人同意将购房过程所涉及的相关信息进行公示，并接受监督。
    </div>
    <div class="title_3">承诺人：</div>
    <div class="title_4">__年__月__日</div>
  </div>
</template>

<script>
import topHeader from "@/components/header";
export default {
  name: "AnnouncePre",
  data() {
    return {
      isWx: sessionStorage.getItem("isWx") || false,
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
.word {
  padding: 0.5rem 0.2rem 0 0.2rem;
  & > div {
    font-size: 0.3rem;
  }
  .title {
    text-align: center;
    font-size: 0.4rem;
    font-weight: bold;
    padding: 0.3rem 0;
  }
  .fixed {
    border-bottom: 1px solid #f5f5f5;
    background-color: #fff;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 9;
    .top_normal {
      height: 100%;
      i {
        font-size: 0.32rem;
      }
    }
  }
  .top_header {
    height: 0.7rem;
    padding: 0.2rem 0rem;
    width: 7.04rem;
    margin: 0 auto;
    &.top_sm {
      padding: 0.1rem;
    }

    .to_map {
      font-size: 0.28rem;
      img {
        margin-right: 0.06rem;
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
  .fixed_pad {
    padding-top: 1.1rem;
  }
}
.title_one {
  padding: 0.2rem 0 0.2rem 0.2rem;
}

.title_2 {
  padding: 0.3rem 0;
  line-height: 0.8rem;
}
.title_4 {
  padding: 0.3rem 0.2rem 0 0;
  text-align: right;
}
</style>